/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe, NgTemplateOutlet } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { ButtonComponent,
    CodeSnippetComponent, ScrollContainerComponent,
    LinkPanelComponent, ModalComponent, PropertiesTableComponent, PropertiesTableRowComponent, SpinnerComponent, FormPasswordInputComponent, requiredValidator, FormComponent, FormActionsComponent, ModalCloseButtonComponent, FormInputComponent
} from "typedb-cloud-framework";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { SnackbarService } from "../../../../../service/snackbar.service";
import { combineLatest, filter, map, shareReplay } from "rxjs";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { ConnectDialogData, PASSWORD_FILLER, parseVersionString, clusterCredentialFilename, copy } from "../../shared";
import { ClusterLoadingTipsComponent } from "../loading/cluster-loading-tips.component";
import { ClusterStatus } from "../../../../../concept/cluster";

@Component({
    selector: "tp-cluster-drivers-connect-dialog",
    templateUrl: "./cluster-drivers-connect-dialog.component.html",
    styleUrls: ["./cluster-drivers-connect-dialog.component.scss"],
    imports: [
        AsyncPipe, MatTooltipModule, MatButtonModule, PropertiesTableComponent, PropertiesTableRowComponent,
        MatSelectModule, ScrollContainerComponent, MatStepperModule,
        MatDialogContent, MatDialogTitle, ModalCloseButtonComponent, ClusterLoadingTipsComponent
    ]
})
export class ClusterDriversConnectDialogComponent {
    serverAddresses$ = combineLatest([this.data.servers$, this.data.cluster$]).pipe(
        filter(([servers, cluster]) => servers.every((server) => !!server.address) && servers.length == cluster.serverCount),
        map(([servers, _]) => servers.map((server) => server.address!)),
        shareReplay(1),
    );
    clusterStatus$ = this.data.cluster$.pipe(map((cluster) => cluster.status));
    ready$ = this.clusterStatus$.pipe(map((status) => status == "running"));

    private loadingStatuses: ClusterStatus[] = ["starting", "resuming"];
    loading$ = this.clusterStatus$.pipe(map((status) => this.loadingStatuses.includes(status)));

    parsedVersion$ = this.data.cluster$.pipe(map(cluster => parseVersionString(cluster.typeDBVersion.version)));
    isTypeDBVersion2$ = this.parsedVersion$.pipe(map(version => version.major == 2));

    docsVersionSpecifier$ = this.isTypeDBVersion2$.pipe(map((isVersion2) => isVersion2 ? "2.x/" : ""));
    driverDocsLink$ = this.docsVersionSpecifier$.pipe(map((specifier) => `https://typedb.com/docs/drivers/${specifier}`));

    constructor(
        private dialogRef: MatDialogRef<ClusterDriversConnectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConnectDialogData, protected snackbar: SnackbarService,
    ) { }

    close() {
        this.dialogRef.close();
    }

    protected readonly PASSWORD_FILLER = PASSWORD_FILLER;
    protected readonly clusterCredentialFilename = clusterCredentialFilename;
    protected readonly copy = copy;
}
